<template>
  <section class="w-screen h-screen absolute flex justify-center items-center z-50">
    <div id="modal modal-table"
      class="modal absolute block bg-white dark:bg-dark-800 w-5/6 shadow-md rounded-lg dark:shadow-dark-600" :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
      }">
      <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
        <h5 class="text-white text-center font-bold text-xl">Pilih Item</h5>
      </div>
      <div id="modal-body" class="p-5 space-y-4 max-h-[calc(100dvh-220px)] overflow-y-auto">
        <SearchBox v-model="searchMenu" placeholder="Cari Menu" class-add="w-full" />
        <LocalFilterLane :items="allItemCategories" class-add="my-3" @setCurrentItem="setCurrentItem" />
        <TableComponent>
          <TableHead>
            <TableRow>
              <TableHeadCell>Kode</TableHeadCell>
              <TableHeadCell>Nama Item</TableHeadCell>
              <TableHeadCell>Action</TableHeadCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow v-if="paginatedItems.length == 0">
              <TableCell colspan="6" customClass="text-center italic text-gray-400 dark:text-gray-500" noTextColor>
                Belum ada data
              </TableCell>
            </TableRow>
            <TableRow v-else v-for="(item, index) in paginatedItems" :key="item.id" :index="index" alternateRow isBody>
              <TableCell>{{ item.code }}</TableCell>
              <TableCell>{{ item.name }}</TableCell>
              <TableCell noTextColor customClass="text-gray-500 dark:text-gray-400 flex">
                <button v-if="selectedItem.filter((i) => i.id == item.id).length == 0" :id="'edit-data-' + item.id"
                  @click="choose(item)"
                  class="border border-gray-400 hover:border-green-700 hover:bg-green-400 flex justify-center items-center mx-1 p-2 rounded-md group">
                  <CheckCircleIcon class="h-4 w-4 group-hover:text-green-700" />
                </button>
                <Badge v-else value="Checked" severity="success"></Badge>
              </TableCell>
            </TableRow>
          </TableBody>
        </TableComponent>
        <PaginationButtons v-model="currentPage" :totalPages="totalPages" />
      </div>
      <div class="modal-footer p-5">
        <div class="flex justify-center">
          <SubmitButton id="close" button_name="Close"
            button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal" />
          <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4"
            @click="submit" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import SubmitButton from '../form/SubmitButton.vue';
import {
  TableComponent,
  TableHead,
  TableRow,
  TableHeadCell,
  TableBody,
  TableCell,
} from "@/components/table";
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import PaginationButtons from '@/components/PaginationButtons.vue';
import Badge from 'primevue/badge';
import SearchBox from '@/views/pages/new-transaction/SearchBox.vue';
import LocalFilterLane from '@/views/pages/new-transaction/order/LocalFilterLane.vue';

export default {
  name: "ModalChooseProduct",
  components: {
    SubmitButton,
    TableComponent,
    TableHead,
    TableRow,
    TableHeadCell,
    TableBody,
    TableCell,
    PaginationButtons,
    CheckCircleIcon,
    SearchBox,
    LocalFilterLane,
    Badge,
  },
  data() {
    return {
      showModal: true,
      selectedItem: [],
      selectedCategory: null,
      searchMenu: '',
      currentPage: 1,
      fields: ['qty'],
      validation: {
        qty: {
          valid: true,
          message: '',
        },
      },
    }
  },
  computed: {
    ...mapGetters('items', ['allItems']),
    ...mapGetters("item_categories", ["allItemCategories"]),
    filteredItems() {
      // Filter item berdasarkan kategori yang dipilih
      let result = this.allItems;
      result = result.map((item) => {
        item.itemCategory = this.allItemCategories.find(
          (ic) => ic.id == item.item_category_id
        );
        return item;
      });

      result = result.filter((item) => item.itemCategory !== undefined);
      if (this.searchMenu)
        result = result.filter(
          (item) =>
            item?.name.toUpperCase().indexOf(this.searchMenu.toUpperCase()) > -1
        );
      if (this.selectedCategory) {
        result = result.filter(
          (item) => item.item_category_id === this.selectedCategory
        );
      }
      return result;
    },
    paginatedItems() {
      const limit = 5;
      const start = (this.currentPage - 1) * limit;
      const end = this.currentPage * limit;
      return this.filteredItems.slice(start, end);
    },
    totalPages() {
      const limit = 5;
      return Math.ceil(this.filteredItems.length / limit);
    },
  },
  watch: {
    showModal(newVal) {
      if (!newVal) {
        this.$emit('closeModal');
      }
    },
    currentPage: {
      immediate: true,
      handler(newVal) {
        this.fetchItems({ page: 1, limit: 1000000000 });
        this.currentPage = newVal;
      },
    },
    searchMenu: {
      immediate: true,
      handler(newVal) {
        this.searchMenu = newVal;
        this.fetchItems({ page: 1, limit: 1000000000 });
        this.currentPage = 1;
      },
    },

  },
  methods: {
    async fetchItems() {
      try {
        const { pagination } = await this.$store.dispatch("items/fetchItems", { page: 1, limit: 1000000000 });
        if (pagination) {
          this.totalPages = pagination.totalPages;
        }
      } catch (error) {
        console.log(error);
      }
    },
    closeModal() {
      this.showModal = false;
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200);
    },
    choose(item) {
      this.selectedItem = [...this.selectedItem, item];
    },
    setCurrentItem(item) {
      this.selectedCategory = item;
      this.currentPage = 1;
      this.fetchItems();
    },
    submit() {
      this.$confirm.require({
        group: 'headless',
        header: 'Apakah anda yakin ingin menyimpan item?',
        message: 'Silahkan konfirmasi sebelum diproses.',
        acceptLabel: 'Ya',
        rejectLabel: 'Tidak',
        accept: () => {
          this.$emit('submit', this.selectedItem);
        },
        reject: () => {
          this.$toast.add({ severity: 'error', summary: 'Rejected', detail: 'Kamu telah membatalkan aksi simpan item', life: 3000 });
        }
      });
    },
  },
  async created() {
    await this.$store.dispatch('items/fetchItems', { limit: 1000000 });
    await this.$store.dispatch("item_categories/fetchItemCategories", {
      limit: 1000,
      status: "active",
    });
  }
}
</script>
